import { Model } from "@/stores/AbstractBase.store";

export class EvaluationLevel implements Model {

	static i18nPrefix = '#evaluation level: ';

	public id?: string;
	public name: string = '';
	public position: number = 0;
	public color: string = '';

	static createFromApiData(data: any) {
		return (new EvaluationLevel()).hydrateWithApiData(data);
	}

	/**
	 * Return the translation key for the name of the level,
	 * or null if this is a custom name.
	 */
	get nameTranslationKey(): string | null {
		if (this.name?.startsWith('$')) {
			return EvaluationLevel.i18nPrefix + this.name.substring(1);
		}

		return null;
	}

	get isPredefinedLevel(): boolean {
		return this.name?.startsWith('$');
	}

	hydrateWithApiData(data: any): EvaluationLevel {

		this.id = data.id;
		this.name = data.name;
		this.position = data.position;
		this.color = data.color;

		return this;
	}

	asApiDataObject() {
		const serverData: any = {
			id: this.id,
			name: this.name,
			position: this.position,
			color: this.color,
		}

		return serverData;
	}

	clone(): EvaluationLevel {
		const clone = new EvaluationLevel();

		clone.id = this.id;
		clone.name = this.name;
		clone.position = this.position;
		clone.color = this.color;

		return clone;
	}

	equals(other: EvaluationLevel): boolean {
		if (!(other instanceof EvaluationLevel)) {
			return false;
		}

		return JSON.stringify(this.asApiDataObject()) === JSON.stringify(other.asApiDataObject());
	}
}
